export type ModalProps = {
    classname?: string;
    title: string;
    content?: string;
    isOpen: boolean;
    isClosable?: boolean;
    btnLabel?: string;
    cancelLabel?: string;
    onCancel?: () => void;
    onConfirm?: () => void;
    children?: React.ReactNode;
};

export default function Modal({
    classname,
    title,
    content,
    isOpen,
    isClosable = true,
    btnLabel,
    cancelLabel = 'Cancel',
    onCancel,
    onConfirm,
    children,
}: ModalProps) {
    return (
        <dialog className="modal" open={isOpen}>
            <div className={`modal-box relative ${classname}`}>
                {isClosable && (
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onCancel}>
                        ✕
                    </button>
                )}
                <h3 className="font-bold text-lg">{title}</h3>
                {content && <p className="py-4">{content}</p>}
                {children && <div className="py-2">{children}</div>}
                <div className="modal-action">
                    {onCancel && (
                        <button className="btn btn-ghost" onClick={onCancel}>
                            {cancelLabel}
                        </button>
                    )}
                    {btnLabel && (
                        <button className="btn btn-primary" onClick={onConfirm}>
                            {btnLabel}
                        </button>
                    )}
                </div>
            </div>
        </dialog>
    );
}
